const schema = () => ({
  type: "object",
  required: [],
  properties: {
    firstname: {
      type: "string",
      title: "firstname",
    },
    lastname: {
      type: "string",
      title: "lastname",
    },
    national_code: {
      type: "string",
      title: "national_code",
      minLength: 10,
      maxLength: 10,
    },
    birth_date: {
      type: "string",
      title: "birthDate",
      format: "date",
    },
    cellphone: {
      type: "string",
      title: "cellphone",
      minLength: 9,
    },
    password: {
      type: "string",
      title: "password",
      minLength: 8,
    },
    medical_number: {
      type: "string",
      title: "medicalNumber",
    },
    specialist: {
      type: "string",
      title: "specialist",
      oneOf: [
        { const: "generalDentist", title: "generalDentist" },
        { const: "restorativeDentistry", title: "restorativeDentistry" },
        { const: "prosthodontics", title: "prosthodontics" },
        { const: "orthodontics", title: "orthodontics" },
      ],
    },
    gender: {
      type: "number",
      title: "gender",
      oneOf: [
        { const: 1, title: "man" },
        { const: 0, title: "woman" },
      ],
    },
    is_active: {
      type: "number",
      title: "activity",
      oneOf: [
        { const: 1, title: "active" },
        { const: 0, title: "inactive" },
      ],
    },
    address: {
      type: "string",
      title: "address",
    },
    email: {
      type: "string",
      title: "email",
      format: "email",
    },
    need_activation: {
      type: "number",
      title: "needActivation",
      oneOf: [
        { const: 1, title: "do" },
        { const: 0, title: "dont" },
      ],
    },
  },
});

export default schema;
